import { ASSOCIATION_MAP, AssociationDirection, AssociationType } from '../constants';
import { ObjectType } from '../tokens-and-interfaces';

export function getAssociationType(fromObject: ObjectType, toObject: ObjectType): AssociationType {
  return ASSOCIATION_MAP.get(fromObject)?.get(toObject) ?? AssociationType.Invalid;
}

function getOrderForCustomObjectAssociations(
  withFromType: string,
  withToType: string,
): { fromType: string; toType: string } {
  const shouldCorrectOrder = withToType.localeCompare(withFromType) === -1;
  if (!withFromType || !withToType || !shouldCorrectOrder) {
    return {
      fromType: withFromType,
      toType: withToType,
    };
  }
  return {
    fromType: withToType,
    toType: withFromType,
  };
}

export function getAssociationDirection(
  objectType: ObjectType,
  associationType: AssociationType,
  withFromType = '',
  withToType = '',
): AssociationDirection {
  const objects = associationType.split('-');
  const fromObject = objects[0];
  const toObject = objects[1];
  if (associationType === 'CustomObject-CustomObject') {
    const { toType } = getOrderForCustomObjectAssociations(withFromType, withToType);
    if (toType !== withToType) {
      return AssociationDirection.To;
    }
    return AssociationDirection.From;
  }
  if (fromObject === objectType) {
    return AssociationDirection.From;
  } else if (toObject === objectType) {
    return AssociationDirection.To;
  }
  return AssociationDirection.Invalid;
}
